/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import ValidatorNumberField from "../../../Validator/ValidatorNumberField";
import { processCostSupportStyle } from "../../processCostSupportStyle";
import { UseForm } from "../../../../types/UseForm";
import { PaymentObligation as PaymentObligationType } from "../../../../types/ProcessCostSupport";

type PaymentObligationProps = {
  path: string;
  paymentObligation: PaymentObligationType;
  handleChange: UseForm["handleChange"];
};

const PaymentObligation = ({ path, paymentObligation, handleChange }: PaymentObligationProps) => {
  return (
    <>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Machen Sie hier bitte nähere Angaben zur Zahlungsverpflichtung / zum Kredit.
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".name"}
          label="Beschreibung"
          margin="normal"
          value={paymentObligation.name}
          helperText={"z.B. Ratenkredit für Auto"}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".remainingTerm"}
          label="Ich zahle noch bis"
          margin="normal"
          value={paymentObligation.remainingTerm}
          helperText={"z.B. 03.05.2023"}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".outstandingDebt"}
          label="Aktuelle Restschuld"
          margin="normal"
          value={paymentObligation.outstandingDebt}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".repayment"}
          label="Zinsen und Tilgung pro Monat"
          margin="normal"
          value={paymentObligation.repayment}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".petitionerShare"}
          label="Ich zahle davon"
          margin="normal"
          value={paymentObligation.petitionerShare}
          onChange={handleChange}
        />
      </Grid>
    </>
  );
};

export default PaymentObligation;
